import { render } from "./ClienteList.vue?vue&type=template&id=af3939c4&scoped=true"
import script from "./ClienteList.vue?vue&type=script&lang=js"
export * from "./ClienteList.vue?vue&type=script&lang=js"

import "./ClienteList.vue?vue&type=style&index=0&id=af3939c4&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af3939c4"]])

export default __exports__